import { arrayMove } from '@dnd-kit/sortable';

/** 商品グループタイプの選択上限。先頭の既定タイプを含めた合計（Hub 用の追加は最大 4） */
export const MAX_PRODUCT_GROUP_TYPES = 5;

/**
 * 選択リスト（先頭 = 既定タイプ、2 つ目以降 = Hub で切り替えて使う追加タイプ）を
 * 保存用の既定タイプ ID / Hub 用 ID 配列に分ける。空リストは既定未設定・Hub 用なし。
 */
export function splitSelection(ids: string[]): {
  productGroupTypeId: string | null;
  hubProductGroupTypeIds: string[];
} {
  return {
    productGroupTypeId: ids[0] ?? null,
    hubProductGroupTypeIds: ids.slice(1),
  };
}

/** 保存済みの値から選択リストを組み立てる（既定タイプが未設定なら空） */
export function buildSelection(
  productGroupTypeId: string | null | undefined,
  hubProductGroupTypeIds: string[] | null | undefined,
): string[] {
  if (!productGroupTypeId) return [];
  return [productGroupTypeId, ...(hubProductGroupTypeIds ?? [])];
}

/** 末尾に追加する。重複と上限超えは無視する */
export function addType(ids: string[], id: string): string[] {
  if (ids.includes(id) || ids.length >= MAX_PRODUCT_GROUP_TYPES) return ids;
  return [...ids, id];
}

export function removeType(ids: string[], id: string): string[] {
  return ids.filter((x) => x !== id);
}

/** ドラッグ / キーボード操作の結果を反映する（active を over の位置へ移す） */
export function moveType(ids: string[], activeId: string, overId: string): string[] {
  const from = ids.indexOf(activeId);
  const to = ids.indexOf(overId);
  if (from < 0 || to < 0 || from === to) return ids;
  return arrayMove(ids, from, to);
}
